import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'
import { CalendarDateTemplateEvent } from 'primereact/calendar'

type Props = {
  date: CalendarDateTemplateEvent
  desiredDeliveryDate?: string
}

export const DateTemplate: React.FC<Props> = ({
  date,
  desiredDeliveryDate,
}) => {
  const { t } = useTranslation()

  const desiredDate = desiredDeliveryDate ? new Date(desiredDeliveryDate) : null

  const isDesiredDate =
    desiredDate &&
    date.day === desiredDate.getDate() &&
    date.month === desiredDate.getMonth() &&
    date.year === desiredDate.getFullYear()

  if (isDesiredDate) {
    return (
      <Button
        className="text-white bg-green-500 w-full h-full flex align-items-center justify-content-center"
        tooltip={t('common.tooltips.requiredDeliveryDate')}
        tooltipOptions={{ position: 'top' }}
      >
        {date.day}
      </Button>
    )
  }

  return <>{date.day}</>
}
